import { objectToUrl } from '../utils/url'
import BetterError from '../utils/BetterError'
import { API_HOST, SANDBOX } from '../shared/settings'

const isServerError = (code = '') => code.toString()[0] === '5'

// NOTE: server check app version and send different data (lol)
// const VERSION = 'APP6.12.3(5)'
const LOCALE = 'en-US'

/**
 * Is enpoint external, like other service or api on different host
 * @example
 * http://someapi.com
 * //someapi.com/
 * @param  {string}  endpoint
 * @return {Boolean}
 */
const isExternalEndpoint = endpoint =>
  endpoint.indexOf('http') === 0 || endpoint.indexOf('//') === 0

export const salesForceCodeSendApi = (code)=> {
  let url = API_HOST + 'activatecode6'
  const method = 'POST'
  const headers = {}
  let payload = {}
  const userLocationData = 'userLocation()'
  let options = {
    method,
    // fetch automatically sets needed headers if FormData is provided in body
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...headers,
    },
    credentials: 'include',
  }
  let defaultParams = {
    lang: LOCALE,
    code,
    production: SANDBOX === 'false',
    webapp: true,
  }
  if (userLocationData.lat && userLocationData.lon) {
    defaultParams = {
      ...defaultParams,
      ...userLocationData,
    }
  }
  payload = {
    ...defaultParams,
    ...payload,
    ...(payload.data && {
      data: {
        ...payload.data,
        production: SANDBOX === 'false',
      },
    }),
  }
  options.body = JSON.stringify(payload)
  fetch(url, options)
}

export const apiCall = (endpoint, payload = {}, method = 'POST', headers = {}) => {
  let customAPIHost = window?.localStorage?.getItem('XO_COMMON_API_HOST')
  if(customAPIHost && !customAPIHost.endsWith('/')){
    customAPIHost = customAPIHost + '/'
  }
  const host = customAPIHost || API_HOST
  const isExternal = isExternalEndpoint(endpoint)
  const isFormData = payload instanceof window.FormData
  let url = isExternal ? endpoint : host + endpoint
  const userLocationData = 'userLocation()'
  // dont forget about {cache: "no-cache"} in get requests

  let options = {
    method,
    // fetch automatically sets needed headers if FormData is provided in body
    ...(!isFormData && {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers,
      },
    }),
    credentials: 'include',
  }
  if(endpoint.includes('gifts')){
     options = {
      method,
      // fetch automatically sets needed headers if FormData is provided in body
      ...(!isFormData && {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...headers,
        },
      })
    }
  }

  if (endpoint.includes('logout')) {
    return fetch(url, options)
  }

  let defaultParams = {
    lang: LOCALE,
    // device: '7BEA41DC59CD59F83E8C3575353471FB416F607850F456F955ACB8A983086475',
    // appVersion: VERSION,
    production: SANDBOX === 'false',
    webapp: true,
  }
  if (userLocationData.lat && userLocationData.lon) {
    defaultParams = {
      ...defaultParams,
      ...userLocationData,
    }
  }

  if (!isExternal && !isFormData) {
    // NOTE: patch inner data with env (for payment, membership endpoints)
    payload = {
      ...defaultParams,
      ...payload,
      ...(payload.data && {
        data: {
          ...payload.data,
          production: SANDBOX === 'false',
        },
      }),
    }
  }

  if (method === 'POST') {
    options.body = !isFormData ? JSON.stringify(payload) : payload
  }
  if (method === 'GET') {
    url = `${url}?${objectToUrl(payload)}`
  }

  // TODO: tests
  // Mocks server responses:
  // 500 http://www.mocky.io/v2/5b3e3cef3000005000abc635
  // url = 'http://www.mocky.io/v2/5b3e3cef3000005000abc635'
  return (
    fetch(url, options)
      // NOTE: if we have a CORS problem, fetch rejected with TypeError
      .catch(error => {
        if (error instanceof TypeError) {
          throw new BetterError(`Server error: ${error.message}`, { isServerError: true })
        }
        throw error
      })
      .then(response => {
        if (isServerError(response.status)) {
          throw new BetterError(response.statusText, { ...response, isServerError: true })
        }
        return response.json()
      })
      .then(response => {
        if (response.data) {
          return response.data
        }
        if (Array.isArray(response)){
          return response
        }
        if (!response.status) {
          if (response?.captchaToken){
            window.localStorage.setItem('captcha-token', response.captchaToken )
          }
          throw new BetterError(response.message, response)
        }
        return response
      })
  )
}
